import React, { useEffect } from 'react'
import { Typography, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, Button } from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'
import {CheckCircle} from '@material-ui/icons'
import {makeStyles} from '@material-ui/core/styles'
import {useParams} from 'react-router-dom'
import Subscriber from '../../services/subscriber'
import logo from '../../logo.png'

const useStyles = makeStyles({
  root: {
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px'
  },
  selected: {
    backgroundColor: 'rgb(56, 52, 150)'
  }
})

export default function PublicProgramSubscribe () {
  const classes = useStyles()
  const {token} = useParams()
  const [loading, setLoading] = React.useState(true)
  const [failed, setFailed] = React.useState(false)
  const [completed, setCompleted] = React.useState(false)
  const [errorCode, setErrorCode] = React.useState(null)
  const [result, setResult] = React.useState(null)

  const errorCodeMap = {
    'error_unexpected_error': {
      'heading': 'Something went wrong!',
      'body': 'Please try clicking the link again, if the issue persists please contact an administrator.'
    },
    'error_invalid_missing_verification_token': {
      'heading': 'Expired or invalid request',
      'body': 'Please try subscribing again, the request has expired or no longer available.'
    },
    'error_already_verified': {
      'heading': 'Email already verified',
      'body': 'You have already verified your email address. You will receive further email instructions or regularly scheduled emails from the program.'
    }
  }

  const getErrorHeading = (code = 'error_unexpected_error') => {
    const err = errorCodeMap[code] ? errorCodeMap[code] : errorCodeMap['error_unexpected_error']
    
    return err.heading
  }

  const getErrorBody = (code = 'error_unexpected_error') => {
    const err = errorCodeMap[code] ? errorCodeMap[code] : errorCodeMap['error_unexpected_error']
    
    return err.body
  }

  useEffect(() => {
    if (loading && !completed && !failed) {
      Subscriber.verifyEmailAddress({token})
        .then(res => {
          setResult(res)
          setCompleted(true)
          setLoading(false)
          setTimeout(() => {
            window.location.href = res.surveyUrl
          }, 7000)
        })
        .catch(err => {
          console.log('verifyEmail.failed', err)
          if (err && err.errors && err.errors.length) {
            setErrorCode(err.errors[0].code)
          } else {
            // some unknown error
            setErrorCode('error_unexpected_error')
          }
          setFailed(true)
          setLoading(false)
        })
    }
  }, [token, completed, failed, loading])

  if (loading) {
    return (
      <Dialog open={true} aria-labelledby="Completing verification">
        <DialogTitle>Completing Verification</DialogTitle>
        <DialogContent style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <CircularProgress color="secondary" />
        </DialogContent>
      </Dialog>
    )
  }

  if (failed) {
    return <div>
      <Dialog classes={{paper: classes.dialog}} open={true} aria-labelledby="Authentication" fullWidth>
        <DialogTitle></DialogTitle>
        <img alt="ResilienceNHope Logo" src={logo} style={{maxWidth: '227px', margin: '0 auto'}} />
        <DialogContent style={{textAlign: 'center'}}>
          <br />
          <Typography variant={'h5'}>{getErrorHeading(errorCode)}</Typography>
          <br />
          <Typography>{getErrorBody(errorCode)}</Typography>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </div>
  }

  if (completed) {
    return <div>
      <Dialog classes={{paper: classes.dialog}} open={true} aria-labelledby="Authentication" fullWidth>
        <DialogTitle></DialogTitle>
        <img alt="ResilienceNHope Logo" src={logo} style={{maxWidth: '227px', margin: '0 auto'}} />
        <DialogContent style={{textAlign: 'center'}}>
          <CheckCircle color={'primary'} />
          <br />
          <Typography variant={'h6'}>Email Verification Completed!</Typography>
          <Typography>You have been verified and subscribed to the requested Program.</Typography>
          {
            result.surveyUrl && (
              <>
                <br />
                <Alert severity="info" style={{textAlign: 'left'}}>
                  <AlertTitle>
                    <strong>
                      Survey Completion Required!
                    </strong>
                  </AlertTitle>
                  <Typography>This program requires you to complete a survey before you can access the program. Please complete the survey to continue.</Typography>
                  <br />
                  <Typography>You will now be redirected to the initial survey, or click on the button below to be redirected to the survey now.</Typography>
                </Alert>
                <br />
                <Typography>
                  <Button variant="contained" color="primary" href={result.surveyUrl}>Complete Survey</Button>
                </Typography>
              </>
            )
          }
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </div>
  }
}